import PageHeader from "../components/pageHeader";
import BlogFeed from "../components/blogFeed";
import { Helmet } from "react-helmet-async";

const title = "Блог G-Factory — статьи о часах CASIO и G-SHOCK";
const description = "Статьи о часах CASIO и G-SHOCK: обзоры моделей, советы по выбору и уходу в блоге G-Factory.";
const canonicalUrl = "https://g-factory.kz/blog";

const BlogPage = () => {
	return (
		<>
			<Helmet>
				<title>{title}</title>
				<meta name="description" content={description} />
				<link rel="canonical" href={canonicalUrl} />
				<meta property="og:type" content="website" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
				<meta property="og:url" content={canonicalUrl} />
			</Helmet>
			<PageHeader
				title="Блог"
				titleTag="h1"
				breadcrumbs={[
					{
						link: "/products",
						text: "Каталог",
					},
					{
						link: "/blog",
						text: "Блог",
					},
				]}
			/>
			<BlogFeed />
		</>
	);
};

export default BlogPage;
